import { PostType } from "@/core/types/contentTypes";

export const getUniquePosts = (prevPosts: PostType[], newPosts: PostType[]): PostType[] => {
  return [...prevPosts, ...newPosts.filter((post) => !prevPosts.find((p) => p.id === post.id))];
};
